import {
  connectEntrataFormConverter,
  connectYardiFormConverter,
  entrataIntegrationSettingsConverter,
  integrationDataExportConverter,
  petChargesCodesUpdateConverter,
  uploadIntegrationSettingsConverter,
  resmanIntegrationConnectConverter,
  resmanIntegrationConverter,
  resmanPropertyConvertor,
  resmanPropertyMatchConverter,
  resmanPropertySycnConverter,
  tpUploadSyncConverter,
  updateEntrataConverter,
  uploadCSVExecuteConverter,
  uploadCSVPreviewConverter,
  // yardiIntegrationInfoConvertor,
  yardiIntegrationSettingsConvertor,
  yardiIntegrationSyncPeriodicityConvertor,
  yardiNotMatchedProperties,
  integrationPropertyConvertor,
  propertyMatchConverter,
  yardiPropertyMatchConverter,
  propertySyncStatus,
  yardiPropertySyncStatus,
  yardiPropertySyncStatusBulk,
  entrataPropertySyncStatusBulk,
} from 'data/converters/integration.converter';
import {
  TConnectEntrataIntegrationUI,
  TConnectYardiIntegrationUI,
  TDeleteEntrataIntegrationDB,
  TEntrataIntegrationSettingsDB,
  TEntrataIntegrationSettingsUI,
  TIntegrationDataExportUI,
  TIntegrationDataUI,
  TIntegrationExecutionResultProps,
  TIntegrationResultProps,
  TIntegrationResultPropsUI,
  TIntegrationType,
  TPropertyForMatchDB,
  TPropertyForMatchUI,
  TPropertySyncStateBulkUI,
  TPropertySyncStateUI,
  TPUploadSyncUI,
  TUploadIntegrationSettingsDB,
  TUploadIntegrationSettingsUI,
  TResmanConnectUI,
  TResmanIntegrationDB,
  TResmanIntegrationUI,
  TResmanPropertiesDB,
  TResmanPropertiesUI,
  TSycnScheduleUI,
  TTPConnectDB,
  TTPDisconnectDB,
  TTPPropertiesDB,
  TTPPropertyLink,
  TTPPropertyToLinkDB,
  TTPPropertyToLinkUI,
  TTPSyncStateProps,
  TUpdateEntrataIntegrationUI,
  TYardiChargeCodesUI,
  TYardiIntegrationSettingsDB,
  TYardiIntegrationSettingsUI,
  TIntegrationPropertyDB,
  TPropertyMatchUI,
  TYardiPropertyMatchUI,
  TYardiPropertySyncStateUI,
  TYardiPropertySyncStateBulkUI,
  TIntegrationPropertyUI,
} from 'data/types/integration.types';
import { EIntegrationUrls } from 'data/urls/integration.url';
import { EPropertyMangerUrl } from 'data/urls/propertyManager.url';
import {
  TPageableDataParamUI,
  TPageableDataWithContent,
  TPageableDataWithContentUi,
} from 'data/types/pagableData.type';
import { queryParamConverter } from 'data/converters/general.converters';
import { pageableDataConverter } from 'data/converters/pagableData.converters';
import { b64toBlob, downloadFile } from 'helpers/fileServices';
import { authSplitApi } from 'redux/helpers/slice.helpers';
import { formatToSnakeCase } from 'helpers/utils';

const baseUrl = `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EIntegrationUrls.CSV}/${EIntegrationUrls.INTEGRATION}`;
const baseYardiUrl = `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EIntegrationUrls.INTEGRATION}/${EIntegrationUrls.YARDI}`;
const baseResmanUrl = `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EIntegrationUrls.INTEGRATION}/${EIntegrationUrls.RESMAN}`;
const baseRealPageUrl = `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EIntegrationUrls.INTEGRATION}/${EIntegrationUrls.REAL_PAGE}`;
const baseApfolioUrl = `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EIntegrationUrls.INTEGRATION}/${EIntegrationUrls.APFOLIO}`;
const baseTPUrl = `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EIntegrationUrls.INTEGRATION}/${EIntegrationUrls.TP}`;
const baseEntrataUrl = `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EIntegrationUrls.INTEGRATION}/${EIntegrationUrls.ENTRATA}`;

export const integrationApi = authSplitApi('integration', [
  'yardiConnection',
  'yardiProperties',
  'resmanConnection',
  'resmanProperties',
  'petChargeStatusEnableValidation',
  'realPageConnection',
  'apfolioConnection',
  'tpProperties',
  'tpPropertiesToLink',
  'entrataConnection',
  'entrataProperties',
]).injectEndpoints({
  endpoints: (build) => ({
    integrationPreview: build.mutation<TIntegrationResultPropsUI, TIntegrationDataUI>({
      query(body) {
        return {
          url: `${baseUrl}/${EIntegrationUrls.PREVIEW}`,
          method: 'POST',
          body: uploadCSVPreviewConverter.toDb(body),
        };
      },
      transformResponse: (data: TIntegrationResultProps) => uploadCSVPreviewConverter.fromDb(data),
    }),
    integrationExecute: build.mutation<TIntegrationExecutionResultProps, TIntegrationDataUI>({
      query(body) {
        return {
          url: `${baseUrl}/${EIntegrationUrls.EXECUTE}`,
          method: 'POST',
          body: uploadCSVExecuteConverter.toDb(body),
        };
      },
      transformResponse: (data: TIntegrationExecutionResultProps) => uploadCSVExecuteConverter.fromDb(data),
    }),
    getIntegrationCSVTemplate: build.query<{ templateUrl: string }, { type: TIntegrationType }>({
      query(params) {
        return {
          url: `${baseUrl}/${EIntegrationUrls.TEMPLATE}`,
          method: 'GET',
          params: { ...params },
        };
      },
    }),
    getYardiIntegration: build.query<TYardiIntegrationSettingsUI, void>({
      query() {
        return {
          url: baseYardiUrl,
          method: 'GET',
        };
      },
      transformResponse: (data: TYardiIntegrationSettingsDB) => yardiIntegrationSettingsConvertor.fromDb(data),
      providesTags: ['yardiConnection'],
    }),
    // getSyncPetChargeEnableValidation: build.query<
    //   TPetChargeSyncEnableValidateUI,
    //   { propertyId?: string; policyId?: string }
    // >({
    //   query({ propertyId, policyId }) {
    //     return {
    //       url: `${baseYardiUrl}/${EIntegrationUrls.CHARGE_SYNC_ENABLE}/${EIntegrationUrls.VALIDATE}`,
    //       method: 'GET',
    //       params: { propertyId, policyId },
    //     };
    //   },
    //   transformResponse: (data: TPetChargeSyncEnableValidateDB) =>
    //     petChargeStatusSyncEnableValidationConvertor.fromDb(data),
    //   providesTags: ['petChargeStatusEnableValidation'],
    // }),
    connectYardiInetgration: build.mutation<void, TConnectYardiIntegrationUI[]>({
      query(body) {
        return {
          url: baseYardiUrl,
          method: 'POST',
          body: {
            connectYardiDtos: body.map((integration) => connectYardiFormConverter.toDb(integration)),
          },
        };
      },
      invalidatesTags: ['yardiProperties', 'yardiConnection'],
    }),
    getYardiIntegrationProperties: build.query<
      TPageableDataWithContentUi<TIntegrationPropertyUI[]>,
      TPageableDataParamUI
    >({
      query({ search, pagination }) {
        return {
          url: `${baseYardiUrl}/${EIntegrationUrls.PROPERTIES}`,
          method: 'GET',
          params: queryParamConverter(search, pagination),
        };
      },
      transformResponse: (data: TPageableDataWithContent<TIntegrationPropertyDB[]>) => {
        const { content, ...other } = data;
        return {
          content: content.map((item) => integrationPropertyConvertor.fromDb(item)),
          paginationData: pageableDataConverter.fromDb(other),
        };
      },
      providesTags: ['yardiProperties'],
    }),
    yardiIntegrationRefreshProperties: build.mutation<void, void>({
      query() {
        return {
          url: `${baseYardiUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.REFRESH}`,
          method: 'POST',
        };
      },
      invalidatesTags: ['yardiProperties'],
    }),
    yardiIntegrationDisconnect: build.mutation<void, string>({
      query(id) {
        return {
          url: `${baseYardiUrl}/${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['yardiProperties', 'yardiConnection'],
    }),
    yardiIntegrationSetFrequency: build.mutation<
      void,
      {
        yardiSettingsId: string;
      } & TSycnScheduleUI
    >({
      query(body) {
        const { yardiSettingsId, ...frequency } = body;
        return {
          url: `${baseYardiUrl}/${EIntegrationUrls.FREQUENCY}`,
          method: 'POST',
          body: {
            yardiSettingsId,
            ...yardiIntegrationSyncPeriodicityConvertor.toDb(frequency),
          },
        };
      },
      invalidatesTags: ['yardiConnection'],
    }),
    yardiChargingCodesUpdate: build.mutation<void, { yardiSettingsId: string } & TYardiChargeCodesUI>({
      query(body) {
        const { yardiSettingsId, ...chargeCodes } = body;
        return {
          url: `${baseYardiUrl}`,
          method: 'PUT',
          body: {
            yardiSettingsId,
            ...petChargesCodesUpdateConverter.toDb(chargeCodes),
          },
        };
      },
      invalidatesTags: ['yardiConnection'],
    }),
    yardiPropertyMatch: build.mutation<void, TYardiPropertyMatchUI>({
      query(body) {
        return {
          url: `${baseYardiUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.LINK}`,
          method: 'POST',
          body: yardiPropertyMatchConverter.toDb(body),
        };
      },
      invalidatesTags: ['yardiProperties'],
    }),
    getNotMatchedProperties: build.query<TPropertyForMatchUI[], { stateIs: string }>({
      query({ stateIs }) {
        return {
          url: `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EIntegrationUrls.INTEGRATION}/${EIntegrationUrls.LINK}/${EIntegrationUrls.PROPERTIES}`,
          method: 'GET',
          params: { stateIs: formatToSnakeCase(stateIs) },
        };
      },
      transformResponse: (data: TPropertyForMatchDB[]) => {
        return data.map((item) => yardiNotMatchedProperties.fromDb(item));
      },
    }),
    yardiGetMissingStates: build.query<string[], void>({
      query() {
        return {
          url: `${baseYardiUrl}/${EIntegrationUrls.MISSING_STATES}`,
          method: 'GET',
        };
      },
      transformResponse: (data: string[]) => {
        return data.map((item) => item.charAt(0) + item.slice(1).toLowerCase());
      },
    }),
    yardiPropertiesSycnState: build.mutation<void, TYardiPropertySyncStateUI>({
      query(body) {
        return {
          url: `${baseYardiUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.SYNC_STATE}`,
          method: 'POST',
          body: yardiPropertySyncStatus.toDb(body),
        };
      },
      invalidatesTags: ['yardiProperties'],
    }),
    yardiPropertiesSyncStateBulk: build.mutation<void, TYardiPropertySyncStateBulkUI>({
      query(body) {
        return {
          url: `${baseYardiUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.SYNC_STATE}/bulk`,
          method: 'POST',
          body: yardiPropertySyncStatusBulk.toDb(body),
        };
      },
      invalidatesTags: ['yardiProperties'],
    }),
    yardiReSync: build.mutation<void, { propertyIds: string[] }>({
      query(body) {
        return {
          url: `${baseYardiUrl}/${EIntegrationUrls.SYNC}`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['yardiProperties'],
    }),
    getResmanIntegration: build.query<TResmanIntegrationUI, void>({
      query() {
        return {
          url: `${baseResmanUrl}`,
          method: 'GET',
        };
      },
      transformResponse: (data: TResmanIntegrationDB) => resmanIntegrationConverter.fromDb(data),
      providesTags: ['resmanConnection'],
    }),
    resmanConnectIntegration: build.mutation<void, TResmanConnectUI>({
      query(body) {
        return {
          url: `${baseResmanUrl}`,
          method: 'POST',
          body: resmanIntegrationConnectConverter.toDb(body),
        };
      },
    }),
    resmanUpdateIntegration: build.mutation<void, TResmanConnectUI>({
      query(body) {
        return {
          url: `${baseResmanUrl}`,
          method: 'PUT',
          body: resmanIntegrationConnectConverter.toDb(body),
        };
      },
    }),
    resmanIntegrationUnlink: build.mutation<void, void>({
      query() {
        return {
          url: `${baseResmanUrl}`,
          method: 'DELETE',
        };
      },
    }),
    getResmanIntegrationProperties: build.query<
      TPageableDataWithContentUi<TResmanPropertiesUI[]>,
      TPageableDataParamUI
    >({
      query({ search, pagination }) {
        return {
          url: `${baseResmanUrl}/${EIntegrationUrls.PROPERTIES}`,
          method: 'GET',
          params: queryParamConverter(search, pagination),
        };
      },
      transformResponse: (data: TPageableDataWithContent<TResmanPropertiesDB[]>) => {
        const { content, ...other } = data;
        return {
          content: content.map((item) => resmanPropertyConvertor.fromDb(item)),
          paginationData: pageableDataConverter.fromDb(other),
        };
      },
      providesTags: ['resmanProperties'],
    }),
    resmanGetMissingStates: build.query<string[], void>({
      query() {
        return {
          url: `${baseResmanUrl}/${EIntegrationUrls.MISSING_STATES}`,
          method: 'GET',
        };
      },
      transformResponse: (data: string[]) => {
        return data.map((item) => item.charAt(0) + item.slice(1).toLowerCase());
      },
    }),
    resmanRefresh: build.mutation<void, void>({
      query(body) {
        return {
          url: `${baseResmanUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.REFRESH}`,
          method: 'POST',
          body,
        };
      },
    }),
    resmanReSync: build.mutation<void, { propertyIds: string[] }>({
      query(body) {
        return {
          url: `${baseResmanUrl}/${EIntegrationUrls.SYNC}`,
          method: 'POST',
          body,
        };
      },
    }),
    resmanPropertyMatch: build.mutation<void, TPropertyMatchUI>({
      query(body) {
        return {
          url: `${baseResmanUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.LINK}`,
          method: 'POST',
          body: resmanPropertyMatchConverter.toDb(body),
        };
      },
    }),
    resmanPropertySyncState: build.mutation<void, TPropertySyncStateUI>({
      query(body) {
        return {
          url: `${baseResmanUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.SYNC_STATE}`,
          method: 'POST',
          body: resmanPropertySycnConverter.toDb(body),
        };
      },
    }),
    resmanSyncPreview: build.query<TIntegrationResultPropsUI, string>({
      query(propertyId) {
        return {
          url: `${baseResmanUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.SYNC}/${EIntegrationUrls.PREVIEW}`,
          method: 'GET',
          params: { propertyId },
        };
      },
      transformResponse: (data: TIntegrationResultProps) => uploadCSVPreviewConverter.fromDb(data),
    }),
    yardiSyncPreview: build.query<TIntegrationResultPropsUI, string>({
      query(propertyId) {
        return {
          url: `${baseYardiUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.SYNC}/${EIntegrationUrls.PREVIEW}`,
          method: 'GET',
          params: { propertyId },
        };
      },
      transformResponse: (data: TIntegrationResultProps) => uploadCSVPreviewConverter.fromDb(data),
    }),
    integrationDataExport: build.query<TIntegrationResultPropsUI, TIntegrationDataExportUI>({
      query(params) {
        return {
          url: `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EIntegrationUrls.INTEGRATION}/${
            EIntegrationUrls.EXPORT
          }/${params.integrationType.toLowerCase()}/${EIntegrationUrls.CSV}`,
          method: 'GET',
          params: integrationDataExportConverter.toDb(params),
          responseHandler: async (response) => {
            const fileArray: { data: string } = await response.json();
            const file = b64toBlob(fileArray.data, 'application/csv');
            downloadFile(file, `${params.integrationType.toLowerCase()}_${params.propertyName}.csv`);
            return null;
          },
        };
      },
    }),
    getRealPageIntegrationSettings: build.query<TUploadIntegrationSettingsUI, void>({
      query() {
        return {
          url: `${baseRealPageUrl}/${EIntegrationUrls.SETTINGS}`,
          method: 'GET',
        };
      },
      transformResponse: (data: TUploadIntegrationSettingsDB) => uploadIntegrationSettingsConverter.fromDb(data),
      providesTags: ['realPageConnection'],
    }),
    getApfolioIntegrationSettings: build.query<TUploadIntegrationSettingsUI, void>({
      query() {
        return {
          url: `${baseApfolioUrl}/${EIntegrationUrls.SETTINGS}`,
          method: 'GET',
        };
      },
      transformResponse: (data: TUploadIntegrationSettingsDB) => uploadIntegrationSettingsConverter.fromDb(data),
      providesTags: ['apfolioConnection'],
    }),
    tpConnect: build.mutation<void, TTPConnectDB>({
      query(body) {
        return {
          url: `${baseTPUrl}/${EIntegrationUrls.CONNECT}`,
          method: 'POST',
          body,
        };
      },
    }),
    tpDisonnect: build.mutation<void, TTPDisconnectDB>({
      query(body) {
        return {
          url: `${baseTPUrl}/${EIntegrationUrls.DISCONNECT}`,
          method: 'DELETE',
          body,
        };
      },
    }),
    tpSyncUpload: build.mutation<void, TPUploadSyncUI>({
      query(body) {
        return {
          url: `${baseTPUrl}/${EIntegrationUrls.SYNC}/${EIntegrationUrls.UPLOAD}`,
          method: 'POST',
          body: tpUploadSyncConverter.toDb(body),
        };
      },
      invalidatesTags: ['tpProperties', 'realPageConnectionx'],
    }),
    getThirdPartyPropertyLinking: build.query<
      TPageableDataWithContentUi<TTPPropertiesDB[]>,
      TPageableDataParamUI & { integrationType: string }
    >({
      query({ search, pagination, integrationType }) {
        return {
          url: `${baseTPUrl}/${EIntegrationUrls.PROPERTIES}?integrationType=${integrationType}`,
          method: 'GET',
          params: queryParamConverter(search, pagination),
        };
      },
      transformResponse: (data: TPageableDataWithContent<TTPPropertiesDB[]>) => {
        const { content, ...other } = data;
        return {
          content,
          paginationData: pageableDataConverter.fromDb(other),
        };
      },
      providesTags: ['tpProperties'],
    }),
    tpPropertiesSync: build.mutation<void, TTPSyncStateProps>({
      query(body) {
        return {
          url: `${baseTPUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.SYNC}`,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: ['tpProperties'],
    }),
    tpPropertyEnable: build.mutation<void, TTPSyncStateProps>({
      query(body) {
        return {
          url: `${baseTPUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.ENABLE}`,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: ['tpProperties'],
    }),
    tpPropertyDisable: build.mutation<void, TTPSyncStateProps>({
      query(body) {
        return {
          url: `${baseTPUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.DISABLE}`,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: ['tpProperties'],
    }),
    tpPropertyLink: build.mutation<void, TTPPropertyLink>({
      query(body) {
        return {
          url: `${baseTPUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.LINK}`,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: ['tpPropertiesToLink', 'tpProperties'],
    }),
    getTpPropertyToLink: build.query<TTPPropertyToLinkUI[], { stateIs?: string }>({
      query({ stateIs }) {
        return {
          url: `${baseTPUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.LINK}`,
          method: 'GET',
          params: stateIs ? { stateIs } : undefined,
        };
      },
      providesTags: ['tpPropertiesToLink'],
      keepUnusedDataFor: 0,
      transformResponse: (data: TTPPropertyToLinkDB[]) =>
        data.map((i) => ({
          value: i.id,
          label: i.name,
          hasAssignedPolicy: i.hasAssignedPolicy,
        })),
    }),
    getYardiPropertyActualData: build.query<
      Uint8Array,
      { yardiPropertyId: string; shouldFetchFullInformation: boolean }
    >({
      query({ yardiPropertyId, shouldFetchFullInformation }) {
        return {
          url: `${baseYardiUrl}/${EIntegrationUrls.COLLECT_TENANT_DETAILS}?yardiPropertyId=${yardiPropertyId}&shouldFetchFullInformation=${shouldFetchFullInformation}`,
          method: 'GET',
        };
      },
    }),
    getYardiAttachementTypes: build.mutation<
      {
        tenantAttachmentTypes: string[];
        prospectAttachmentTypes: string[];
      },
      {
        username: string;
        password: string;
        database: string;
        baseUrl: string;
      }
    >({
      query(body) {
        return {
          url: `${baseYardiUrl}/configured-attachment-types`,
          method: 'POST',
          body,
        };
      },
    }),
    getAttachementTypes: build.mutation<
      {
        tenantAttachmentTypes: string[];
        prospectAttachmentTypes: string[];
      },
      {
        settingsId: string;
      }
    >({
      query({ settingsId }) {
        return {
          url: `${baseYardiUrl}/configured-attachment-types/by-settings`,
          method: 'GET',
          params: { settingsId },
        };
      },
    }),
    // ============ ENTRATA ENDPOINTS ============
    getEntrataIntegration: build.query<TEntrataIntegrationSettingsUI, void>({
      query() {
        return {
          url: baseEntrataUrl,
          method: 'GET',
        };
      },
      transformResponse: (data: TEntrataIntegrationSettingsDB) => entrataIntegrationSettingsConverter.fromDb(data),
      providesTags: ['entrataConnection'],
    }),
    connectEntrataIntegration: build.mutation<void, TConnectEntrataIntegrationUI[]>({
      query(body) {
        return {
          url: baseEntrataUrl,
          method: 'POST',
          body: {
            connectEntrataDtos: body.map((integration) => connectEntrataFormConverter.toDb(integration)),
          },
        };
      },
      invalidatesTags: ['entrataConnection'],
    }),
    updateEntrataIntegration: build.mutation<void, TUpdateEntrataIntegrationUI>({
      query(body) {
        return {
          url: baseEntrataUrl,
          method: 'PUT',
          body: updateEntrataConverter.toDb(body),
        };
      },
      invalidatesTags: ['entrataConnection'],
    }),
    disconnectEntrataIntegration: build.mutation<void, TDeleteEntrataIntegrationDB>({
      query(body) {
        return {
          url: baseEntrataUrl,
          method: 'DELETE',
          body,
        };
      },
      invalidatesTags: ['entrataConnection'],
    }),
    entrataIntegrationSetFrequency: build.mutation<
      void,
      {
        entrataSettingsId: string;
      } & TSycnScheduleUI
    >({
      query(body) {
        const { entrataSettingsId, ...frequency } = body;
        return {
          url: `${baseEntrataUrl}/${EIntegrationUrls.FREQUENCY}`,
          method: 'PUT',
          body: {
            entrataSettingsId,
            ...yardiIntegrationSyncPeriodicityConvertor.toDb(frequency),
          },
        };
      },
      invalidatesTags: ['entrataConnection'],
    }),
    entrataChargingCodesUpdate: build.mutation<void, TUpdateEntrataIntegrationUI>({
      query(body) {
        return {
          url: baseEntrataUrl,
          method: 'PUT',
          body: updateEntrataConverter.toDb(body),
        };
      },
      invalidatesTags: ['entrataConnection'],
    }),
    getEntrataAttachmentTypes: build.mutation<
      {
        tenantAttachmentTypes: string[];
        prospectAttachmentTypes: string[];
      },
      {
        organizationId: string;
      }
    >({
      query(body) {
        return {
          url: `${baseEntrataUrl}/configured-attachment-types`,
          method: 'POST',
          body,
        };
      },
    }),
    // ============ ENTRATA PROPERTIES endpoints ============
    getEntrataIntegrationProperties: build.query<
      TPageableDataWithContentUi<TIntegrationPropertyUI[]>,
      TPageableDataParamUI
    >({
      query({ search, pagination }) {
        return {
          url: `${baseEntrataUrl}/${EIntegrationUrls.PROPERTIES}`,
          method: 'GET',
          params: queryParamConverter(search, pagination),
        };
      },
      transformResponse: (data: TPageableDataWithContent<TIntegrationPropertyDB[]>) => {
        const { content, ...other } = data;
        return {
          content: content.map((item) => integrationPropertyConvertor.fromDb(item)),
          paginationData: pageableDataConverter.fromDb(other),
        };
      },
      providesTags: ['entrataProperties'],
    }),
    entrataIntegrationRefreshProperties: build.mutation<void, void>({
      query() {
        return {
          url: `${baseEntrataUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.REFRESH}`,
          method: 'POST',
        };
      },
      invalidatesTags: ['entrataProperties'],
    }),
    entrataPropertyMatch: build.mutation<void, TPropertyMatchUI>({
      query(body) {
        return {
          url: `${baseEntrataUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.LINK}`,
          method: 'POST',
          body: propertyMatchConverter.toDb(body),
        };
      },
      invalidatesTags: ['entrataProperties'],
    }),
    entrataPropertiesSyncState: build.mutation<void, TPropertySyncStateUI>({
      query(body) {
        return {
          url: `${baseEntrataUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.SYNC_STATE}`,
          method: 'POST',
          body: propertySyncStatus.toDb(body),
        };
      },
      invalidatesTags: ['entrataProperties'],
    }),
    entrataReSync: build.mutation<void, { propertyIds: string[] }>({
      query(body) {
        return {
          url: `${baseEntrataUrl}/${EIntegrationUrls.SYNC}`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['entrataProperties'],
    }),
    entrataSyncPreview: build.query<TIntegrationResultPropsUI, string>({
      query(propertyId) {
        return {
          url: `${baseEntrataUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.SYNC}/${EIntegrationUrls.PREVIEW}`,
          method: 'GET',
          params: { propertyId },
        };
      },
      transformResponse: (data: TIntegrationResultProps) => uploadCSVPreviewConverter.fromDb(data),
    }),
    entrataPropertiesSyncStateBulk: build.mutation<void, TPropertySyncStateBulkUI>({
      query(body) {
        return {
          url: `${baseEntrataUrl}/${EIntegrationUrls.PROPERTIES}/${EIntegrationUrls.SYNC_STATE}/bulk`,
          method: 'POST',
          body: entrataPropertySyncStatusBulk.toDb(body),
        };
      },
      invalidatesTags: ['entrataProperties'],
    }),
    getEntrataPropertyActualData: build.query<Uint8Array, { entrataPropertyId: string }>({
      query({ entrataPropertyId }) {
        return {
          url: `${baseEntrataUrl}/${EIntegrationUrls.COLLECT_TENANT_DETAILS}?entrataPropertyId=${entrataPropertyId}`,
          method: 'GET',
        };
      },
    }),
  }),

  overrideExisting: false,
});

export const {
  useIntegrationPreviewMutation,
  useIntegrationExecuteMutation,
  useGetIntegrationCSVTemplateQuery,
  useGetYardiIntegrationQuery,
  useConnectYardiInetgrationMutation,
  useGetYardiIntegrationPropertiesQuery,
  useYardiIntegrationRefreshPropertiesMutation,
  useYardiIntegrationDisconnectMutation,
  useYardiIntegrationSetFrequencyMutation,
  useYardiChargingCodesUpdateMutation,
  useYardiPropertyMatchMutation,
  useLazyGetNotMatchedPropertiesQuery,
  useYardiGetMissingStatesQuery,
  useYardiPropertiesSycnStateMutation,
  useYardiReSyncMutation,
  useResmanConnectIntegrationMutation,
  useGetResmanIntegrationQuery,
  useResmanUpdateIntegrationMutation,
  useResmanIntegrationUnlinkMutation,
  useGetResmanIntegrationPropertiesQuery,
  useResmanGetMissingStatesQuery,
  useResmanRefreshMutation,
  useResmanReSyncMutation,
  useResmanPropertyMatchMutation,
  useResmanPropertySyncStateMutation,
  useYardiSyncPreviewQuery,
  useResmanSyncPreviewQuery,
  useLazyIntegrationDataExportQuery,
  // useGetSyncPetChargeEnableValidationQuery,
  useGetRealPageIntegrationSettingsQuery,
  useGetApfolioIntegrationSettingsQuery,
  useTpConnectMutation,
  useTpDisonnectMutation,
  useTpSyncUploadMutation,
  useGetThirdPartyPropertyLinkingQuery,
  useTpPropertiesSyncMutation,
  useTpPropertyDisableMutation,
  useTpPropertyEnableMutation,
  useTpPropertyLinkMutation,
  useGetTpPropertyToLinkQuery,
  useLazyGetYardiPropertyActualDataQuery,
  useYardiPropertiesSyncStateBulkMutation,
  useGetYardiAttachementTypesMutation,
  useGetAttachementTypesMutation,
  // Entrata
  useGetEntrataIntegrationQuery,
  useConnectEntrataIntegrationMutation,
  useUpdateEntrataIntegrationMutation,
  useDisconnectEntrataIntegrationMutation,
  useEntrataIntegrationSetFrequencyMutation,
  useEntrataChargingCodesUpdateMutation,
  useGetEntrataAttachmentTypesMutation,
  // Entrata Properties
  useGetEntrataIntegrationPropertiesQuery,
  useEntrataIntegrationRefreshPropertiesMutation,
  useEntrataPropertyMatchMutation,
  useEntrataPropertiesSyncStateMutation,
  useEntrataReSyncMutation,
  useEntrataSyncPreviewQuery,
  useEntrataPropertiesSyncStateBulkMutation,
  useLazyGetEntrataPropertyActualDataQuery,
} = integrationApi;
